import type { ImageSourcePropType } from 'react-native';

export type IQESSceneKey =
  | 'stormSea'
  | 'spiritStorm'
  | 'parchment'
  | 'sunsetCross'
  | 'templeOrdering';

export type IQESScenePreset = {
  image: ImageSourcePropType;
  overlay: readonly [string, string, ...string[]];
};

export const iqesSceneAssets: Record<IQESSceneKey, ImageSourcePropType> = {
  stormSea: require('../../../assets/iqes/storm-sea.png'),
  spiritStorm: require('../../../assets/iqes/spirit-storm.png'),
  parchment: require('../../../assets/iqes/parchment-surface.png'),
  sunsetCross: require('../../../assets/iqes/sunset-cross.png'),
  templeOrdering: require('../../../assets/iqes/temple-ordering.png'),
};

export const iqesScenePresets: Record<IQESSceneKey, IQESScenePreset> = {
  stormSea: {
    image: iqesSceneAssets.stormSea,
    overlay: ['rgba(6, 10, 26, 0.22)', 'rgba(6, 7, 18, 0.42)'],
  },
  spiritStorm: {
    image: iqesSceneAssets.spiritStorm,
    overlay: ['rgba(37, 11, 67, 0.16)', 'rgba(6, 7, 18, 0.5)'],
  },
  parchment: {
    image: iqesSceneAssets.parchment,
    overlay: ['rgba(12, 6, 3, 0)', 'rgba(12, 6, 3, 0.08)'],
  },
  sunsetCross: {
    image: iqesSceneAssets.sunsetCross,
    overlay: ['rgba(70, 22, 7, 0.03)', 'rgba(8, 6, 15, 0.46)'],
  },
  templeOrdering: {
    image: iqesSceneAssets.templeOrdering,
    overlay: ['rgba(11, 6, 22, 0.14)', 'rgba(5, 4, 12, 0.58)'],
  },
};

export const DEFAULT_IQES_SCENE_KEY: IQESSceneKey = 'parchment';

export const inferIQESSceneKey = (input: {
  question?: string | null;
  questionType?: string | null;
  verseReference?: string | null;
  category?: string | null;
}): IQESSceneKey => {
  const haystack = [
    input.question,
    input.questionType,
    input.verseReference,
    input.category,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  if (/\b(water|sea|boat|storm|waves|galilee|peter)\b/.test(haystack)) {
    return 'stormSea';
  }

  if (/\b(spirit|fruit|galatians|peace|patience|kindness|joy|love)\b/.test(haystack)) {
    return 'spiritStorm';
  }

  if (/\b(cross|crucif|resurrection|john 3:16|son|loved|eternal life)\b/.test(haystack)) {
    return 'sunsetCross';
  }

  if (/\b(temple|priest|tabernacle|order|sequence|exodus|creation|flood|babel)\b/.test(haystack)) {
    return 'templeOrdering';
  }

  return DEFAULT_IQES_SCENE_KEY;
};
